import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';

const blogPosts = [
  {
    slug: '/blog/what-is-a-lady-bird-deed-florida',
    title: 'What Is a Lady Bird Deed in Florida?',
    excerpt: 'Everything you need to know about how Lady Bird Deeds work in Florida.',
    date: 'January 20, 2025'
  },
  {
    slug: '/blog/lady-bird-deed-vs-living-trust-florida',
    title: 'Lady Bird Deed vs Living Trust',
    excerpt: 'An honest comparison to help you choose the right option.',
    date: 'January 20, 2025'
  },
  {
    slug: '/blog/does-lady-bird-deed-avoid-probate-florida',
    title: 'Does a Lady Bird Deed Avoid Probate?',
    excerpt: 'Yes — here\'s exactly how it works and what your heirs need to do.',
    date: 'January 20, 2025'
  }
];

const BlogPreviewSection = () => {
  return (
    <section className="py-16 bg-[#0a0a0a]">
      <div className="absolute top-0 left-0 right-0 divider-elegant" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="font-sans text-xs tracking-[0.3em] uppercase text-[#c9a87c] mb-4 block">
              Resources
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-[#faf9f7]">
              Lady Bird Deed <span className="text-gradient-gold">Articles</span>
            </h2>
          </div>
          <Link 
            to="/blog"
            className="inline-flex items-center gap-2 text-[#c9a87c] hover:text-[#d4b896] font-sans text-sm transition-colors"
          >
            View All Articles
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {blogPosts.map((post, index) => (
            <Link
              key={index}
              to={post.slug}
              className="group bg-gradient-to-br from-[#141414] to-[#0f0f0f] border border-[#c9a87c]/10 rounded-lg p-6 hover:border-[#c9a87c]/30 transition-all"
            >
              <div className="flex items-center gap-2 text-xs text-[#faf9f7]/50 mb-3">
                <Calendar className="w-3 h-3" />
                <span>{post.date}</span>
              </div>
              <h3 className="font-serif text-xl text-[#faf9f7] mb-2 group-hover:text-[#c9a87c] transition-colors">
                {post.title}
              </h3>
              <p className="font-sans text-sm text-[#faf9f7]/60 mb-4">
                {post.excerpt}
              </p>
              <span className="inline-flex items-center gap-1 text-[#c9a87c] text-sm font-sans">
                Read More
                <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreviewSection;
